import { render, staticRenderFns } from "./EnrollmentReenrollConceptsDialog.vue?vue&type=template&id=3d870f34&"
import script from "./EnrollmentReenrollConceptsDialog.vue?vue&type=script&lang=ts&"
export * from "./EnrollmentReenrollConceptsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports